import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { fetchData, fetchDataById, postData, putData } from "../../../services"
import { useOperationKeyValueFormHandling } from './components/OperationKeyValueStateHandle.js'
import MaterialInput from "../../../components/MaterialInput/index.js"
import MaterialSelect from "../../../components/MasterSelect/index.js"
import { useEffect, useState } from "react"
import MaterialButton from "../../../components/MaterialButton/index.js"
import MaterialBox from "../../../components/MaterialBox/index.js"

const OperationStoreForm = () => {

    const [searchParams] = useSearchParams();
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
    const location = useLocation();
    const categoryId = location?.state?.categoryId || "";
    const categoryName = location?.state?.categoryName || "";
    
    const operationKVStoreId = searchParams.get("id");
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const [operationCategoryOptions, setOperationCategoryOptions] = useState([]);    
    const [parentKeyOptions, setParentKeyOptions] = useState([]);

    useEffect(() => {

        setKeyValueData((prev) => ({
            ...prev,
            category: { label: categoryName, value: categoryId },
            categoryStatus: categoryId ? "success" : "undefined",
        }));
        const fetchAllDropdowns = async () => {
            setCircleLoading(true);

            try {
                const [dropdownRes, parentKeyRes] = await Promise.allSettled([
                fetchData(`/orchestration/key-value-category?isActive=true&dropdown=true`),
                fetchData(`/orchestration/key-value-store?categoryId=${categoryId || ""}&isActive=true&dropdown=true`)
                ]);

                if (dropdownRes?.value?.success) {
                    
                    setOperationCategoryOptions(
                        dropdownRes?.value?.data?.items?.map(item => ({
                            value: item.id,
                            label: item.categoryName,
                        })) || []
                    );
                }

                if (parentKeyRes?.value?.success) {
                    setParentKeyOptions(
                        parentKeyRes?.value?.data?.items?.map(item => ({
                            value: item.id,
                            label: item.keyName,
                        })) || []
                    )
                }

            } catch (error) {
                console.error("Error fetching data:", error);
                showSnackbar("Error fetching data", "warning");
            } finally {
                setCircleLoading(false);
            }
        };
        if(pageMode !== "view"){
            fetchAllDropdowns();
        }

    }, [categoryName]);

    useEffect(() => {
        const fetchData = async () => {

            if (operationKVStoreId) {
            setCircleLoading(true);
            try {
                const response = await fetchDataById(`/orchestration/key-value-store/${operationKVStoreId}`);

                const responseData = response?.data;
                
                if (response.success) {
                    const mapped = {
                        code: responseData?.code || "",
                        keyName: responseData?.keyName || "",

                        // dropdowns (reverse of payload)
                        category: responseData?.category
                        ? { value: responseData.category.id, label: responseData.category.categoryName }
                        : null,

                        iRegistryId: responseData?.iRegistryId
                        ? { value: responseData.iRegistryId, label: responseData.iRegistryId }
                        : null,

                        active: responseData?.isActive,

                        // status fields
                        codeStatus: responseData?.code ? "success" : "unchecked",
                        keyNameStatus: responseData?.keyName ? "success" : "unchecked",
                        categoryStatus: responseData?.category?.id ? "success" : "unchecked",
                        iRegistryIdStatus: responseData?.iRegistryId ? "success" : "unchecked",
                        workflowCategoryIdStatus: responseData?.workflowCategory ? "success" : "unchecked",
                    };

                    setKeyValueData(mapped);  
                }
            } catch (error) {
                console.error("Error Fetching:",error);
                showSnackbar(error?.response?.data?.message,"error");
            } finally {
                setCircleLoading(false);
            }
            }
        };

        fetchData();
    }, [operationKVStoreId]);

    //handle submit api function    
    const handleAddKeyValue = async () => {

        const payload = { 
            categoryId: categoryId,
            keyName: keyValueData?.keyName,
            parentKeyId: keyValueData?.parentKeyId?.value ? keyValueData?.parentKeyId?.value : null,
            code: keyValueData?.code,
            isActive: keyValueData?.active
        };
        //update
        if(operationKVStoreId){
            try {
                const response = await putData(`/orchestration/key-value-store/${operationKVStoreId}`, payload);
                if(response.success){
                    navigate("/operation/operation-store");
                    showSnackbar(response?.message,"success");
                }
                else{
                    showSnackbar(response?.message,"error");
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message,"error");
            }
        }

        try {
            const response = await postData('/orchestration/key-value-store', payload);
            const successResponse = response?.success;
            const responseMessage = response?.message;
            if(successResponse){
                showSnackbar(responseMessage,"success");
                navigate("/operation/operation-store");
            }
            else{
                showSnackbar(responseMessage,"error");
            }
        } catch (error) {
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message,"error");
        }
    };

    const { keyValueData, setKeyValueData, handleKeyValueDataChange, checkAllFields } = useOperationKeyValueFormHandling();
    
  return (
    <DashboardLayout>
        <CardHeader
        title={
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={() => navigate("/operation/operation-store")}>
                        <ArrowBack />
                    </IconButton>
                    <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Operation Store Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        Enter New Operation Store Details of respective Category.
                    </MaterialTypography>
                    </Stack>
                </Stack>
            </Stack>
        }
        />
        <CardContent sx={{ minHeight: "65vh" }}>
            <Grid2 container spacing={1}>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                    >
                        Category*
                    </MaterialTypography>
                    <MaterialSelect
                    name="category"
                    value={keyValueData.category}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleKeyValueDataChange} //selectedValue, event
                    options={operationCategoryOptions?.map((value) => {
                        return {
                        value: value.value,
                        label: value.label,
                        };
                    })}
                    error={keyValueData.categoryStatus === "error" ? true : false}
                    success={
                        keyValueData.categoryStatus === "success" ? true : false
                    }
                    isDisabled={categoryId}
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                    >
                        {categoryName} Name*
                    </MaterialTypography>
                    <MaterialInput
                    name="keyName"
                    placeholder="eg. key name"
                    value={keyValueData.keyName}
                    onChange={handleKeyValueDataChange}
                    error={keyValueData.keyNameStatus === "error" ? true : false}
                    success={
                        keyValueData.keyNameStatus === "success" ? true : false
                    }
                    disabled={pageMode === "view"}
                    />
                    {keyValueData.keyNameStatus === "error" && (
                    <FormControl error>
                        <FormHelperText>
                        Name should be minimum of 1 character and maximum of 170 characters long.
                        </FormHelperText>
                    </FormControl>
                    )}
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                    >
                        Parent Key ID
                    </MaterialTypography>
                    <MaterialSelect
                    name="parentKeyId"
                    value={keyValueData.parentKeyId}
                    options={parentKeyOptions}
                    onChange={handleKeyValueDataChange}
                    error={
                        keyValueData.parentKeyIdStatus === "error" ? true : false
                    }
                    success={
                        keyValueData.parentKeyIdStatus === "success" ? true : false
                    }
                    isDisabled={pageMode === "view"}
                    />
                    {keyValueData.parentKeyIdStatus === "error" && (
                    <FormControl error>
                        <FormHelperText>
                        Name should be maximum 20 characters long and can contain
                        only alphabets
                        </FormHelperText>
                    </FormControl>
                    )}
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                    >
                        Code*
                    </MaterialTypography>
                    <MaterialInput
                    name="code"
                    placeholder="eg. CODE21"
                    value={keyValueData.code}
                    onChange={handleKeyValueDataChange}
                    error={keyValueData.codeStatus === "error" ? true : false}
                    success={
                        keyValueData.codeStatus === "success" ? true : false
                    }
                    disabled={pageMode === "view"}
                    />
                    {keyValueData.codeStatus === "error" && (
                    <FormControl error>
                        <FormHelperText>
                        Code should be maximum 20 characters long
                        </FormHelperText>
                    </FormControl>
                    )}
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 2 }}>
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                    >
                        Active
                    </MaterialTypography>
                    <FormControlLabel
                    control={
                        <Switch
                        name="active"
                        checked={keyValueData.active}
                        onChange={(event) =>
                            handleKeyValueDataChange({
                            target: {
                                name: "active",
                                value: event.target.checked,
                            },
                            })
                        }
                        disabled={pageMode === "view"}
                        color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                        {keyValueData?.active ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>
            </Grid2>
        </CardContent>
        <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        >
            {pageMode !== "view" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/operation/operation-store")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddKeyValue}
                >
                {pageMode === "edit" ? "Update" : "Submit"}
                </MaterialButton>
            </>
            )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default OperationStoreForm